import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchObtenerPublicacion = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/api/comunicacion/blog/${id}`);

        return response.data;
    } catch (error) {
        //handleAuthError(error);
    }
};


export const fetchPublicacionFilters = async (paginaActual, busqueda, webDestino) => {

    try {
        const response = await axios.post(`${API_URL}/api/comunicacion/blogs/filters`, {
            "current_page": paginaActual || 1,
            "items_per_page": 10,
            "order": busqueda,
            "webDestino": webDestino

        }); 
        

        return response.data;
    } catch (error) {
        console.log("Ha habido un error:", error);
        throw error;
    }
};




